import { DiceD20OutlineIcon } from './DiceD20OutlineIcon';

/**
 * author: Austin Andrews
 * id 926FAA94-AB58-44AA-916C-66AF56A5BCCF
 * name dice-d20-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-d20-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const DieD20Icon = DiceD20OutlineIcon;
export default DieD20Icon